import "./App.css";
import Layout from "./Layout";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import { useEffect, useState } from "react";
import { AppProvider } from "./Context/AppProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ManageDoc from "./pages/admin/ManageDoc";
import QuestionList from "./pages/admin/QuestionList";
import Settings from "./pages/admin/Settings";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import PageNotFound from "./pages/PageNotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import UserChatHistory from "./pages/admin/ChatHistory";
import ManageLessonTable from "./pages/admin/ManageLessonTable";

function App() {
  const [darkMode, setDarkMode] = useState(true); // Default to dark mode

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    // If no theme is stored, default to dark mode
    if (theme === null) {
      setDarkMode(true);
      localStorage.setItem("theme", "dark");
    } else {
      setDarkMode(theme === "dark");
    }
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={darkMode ? "dark" : "light"}
      />
      <AppProvider>
        <Routes>
          {/* Routes without layout */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="*" element={<PageNotFound />} />

          {/* Routes with layout */}
          <Route
            path="/"
            element={
              <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/chat/:sessionId"
            element={
              <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/admin/docs"
            element={
              <ProtectedRoute>
                <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
                  <ManageDoc />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/questions"
            element={
              <ProtectedRoute>
                <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
                  <QuestionList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute>
                <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />

              <Route
            path="/admin/chat-history"
            element={
              <ProtectedRoute>
                <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
                  <UserChatHistory />
                </Layout>
              </ProtectedRoute>
            }
          />


               <Route
            path="/admin/lessons"
            element={
              <ProtectedRoute>
                <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
                  <ManageLessonTable />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;
